<app-module-header
  [title]="organization.organizationName + ' - ' + ('OPEN_GATE.MAINTENANCE_GATES' | transloco)"
icon="handyman"></app-module-header>

@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<mat-tab-group syncTabsWithUrl>
  <mat-tab label="Maintenance Gates" urlKey="gates">
    <div class="parking-container">
      @for (parking of parkings; track parking) {
        <div>
          @if (parking.gates?.length > 0) {
            <div class="parking-section">
              <h2 class="parking-title">{{ parking.name }}</h2>
              <div class="gates-grid row g-2">
                @for (cam of parking.gates; track cam) {
                  <div class="col-6">
                    <div class="gate-card"
                      (click)="isMobile ? openGate(cam.externalId) : null">
                      <div class="gate-info">
                        <div class="gate-name">{{ cam.description }}</div>
                        <div class="gate-type">{{ getGateType(cam.gateType) }}</div>
                      </div>
                      <button mat-raised-button color="primary" class="gate-button"
                        [disabled]="openingGateCode === cam.externalId"
                        (click)="openGate(cam.externalId)">
                        @if (openingGateCode === cam.externalId) {
                          <mat-icon class="spinner">autorenew</mat-icon>
                        }
                        @if (openingGateCode !== cam.externalId) {
                          <span>{{ 'OPEN_GATE.TITLE' | transloco }}</span>
                        }
                        @if (openingGateCode === cam.externalId) {
                          <span>Opening...</span>
                        }
                      </button>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </mat-tab>
</mat-tab-group>
